import React from "react";

import { Wrapper, CardBody, Title, Copy } from "app/NativeComponents/common";

const BulkUploadCopy = props => {
  return (
    <Wrapper
      style={{
        minWidth: 350,
        maxWidth: 400,
        flex: 1
      }}
    >
      <CardBody>
        <Title>Map your spreadsheet to DealMachine.</Title>
        <Copy>
          Once you submit your list, we'll look up the property owners and add
          them to your account. We'll send you an email once your import is
          complete.
        </Copy>
      </CardBody>
    </Wrapper>
  );
};

export default BulkUploadCopy;
